module.exports = __webpack_public_path__ + "static/media/MINISERIF-MEDIUM.8d46c57d.TTF";